/*
 * HONEYWELL INC.,
 * COPYRIGHT (c) 2022
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */

import React from 'react';
import { ICellData } from '@scuf/datatable/dist/components/DataTable/IDataTableInterfaces';
import {
  PERCENT_CHANGE_THRESHOLD,
  UtilityMeterField
} from '../../../shared/Utils/Constants';
import UtilitySiteMeterColumnComponent from './UtilitySiteMeterColumnComponent';
import { formatCurrency } from '../../../shared/Utils/Utils';
import UtilityActualCostColumnComponent from './UtilityActualCostColumnComponent';
import UtilityCostChangeColumnComponent from './UtilityCostChangeColumnComponent';

export const IColumnFields = {
  siteName: 'siteName',
  totalActualCost: 'totalActualCost',
  previousPeriodCost: 'previousPeriodCost',
  costSavings: 'costSavings'
};

interface IUtilityCellDataRenderer {
  cellData: ICellData;
  utilityCostCurrency: string;
}

const utilityCellDataRenderer = (props: IUtilityCellDataRenderer) => {
  const { cellData, utilityCostCurrency } = props;
  const { value, field, rowData } = cellData;
  const currencyconverter = formatCurrency(value, utilityCostCurrency);
  switch (field) {
    case UtilityMeterField.siteName:
      return (
        <UtilitySiteMeterColumnComponent
          savings={rowData.costSavings}
          name={value}
          id={rowData.siteId}
        />
      );
    case UtilityMeterField.totalActualCost:
      const actualCostProps = {
        currencyconverter,
        actual: rowData.totalActualCost,
        previousPeriod: rowData.previousPeriodCost,
        savings: rowData.costSavings,
        savingsPercentage: rowData.savingsPercentage,
        progessBarRelativeWidth: rowData.progessBarRelativeWidth
      };
      return <UtilityActualCostColumnComponent {...actualCostProps} />;
    case UtilityMeterField.costSavings:
      if (value === null) {
        return <span className="score-category-meterdata-meter">--</span>;
      } else {
        return (
          <UtilityCostChangeColumnComponent
            savingsPercentage={rowData.savingsPercentage}
            value={value}
            currencyconverter={currencyconverter}
          />
        );
      }

    case UtilityMeterField.previousPeriodCost:
      return (
        <span className="score-category-meterdata-meter">
          <div className="consumptionvalue">{currencyconverter}</div>
        </span>
      );
    default:
      return <></>;
  }
};

export default utilityCellDataRenderer;
